import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import {Wrapper} from './styles';
import { PageHero } from '../../components';
import axios from "axios";
import { toast } from 'react-toastify';



const ContactUsPage = () => {
  const location = useLocation();
  const [name, setName]=useState("")
  const [email, setEmail]=useState("")
  const [phoneNumber, setPhoneNumber]=useState("")
  const [purpose, setPurpose]=useState("")
  const [isBtnDisabled, setIsBtnDisabled]=useState(false)
  const history=useHistory()

  useEffect(() => {
    document.title = 'Mukunda Jwellers | Contact Us';

    // Scroll to the corresponding section if there's a hash in the URL
    const hash = location.hash;
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);
  const handleSubmit=async(e)=>{
    e.preventDefault()
    const payload={name, phoneNumber, email, purpose}
    let res = await axios.post(`${process.env.REACT_APP_BACKEND_HOST}/api/contactus/new`, payload);
    if(res.data.success){
      toast.success("Request raised for contact support")
      history.push("/collections")
    }

  }

  
  return (
    <main>
      <PageHero title='Contact Us' />
      <Wrapper>
        <div className='checkout-wrapper'>
          <div className='checkout-card'>
            <h2 className='checkout-title'>Contact Us</h2>
   

            <form onSubmit={handleSubmit} className='checkout-form'>
              <input
                type='text'
                name='name'
                placeholder='Customer Name'
                value={name}
                onChange={(e) => setName(e.target.value)}
                className='form-input'
              />

              <input
                type='number'
                name='phone_number'
                placeholder='Phone Number'
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                className='form-input'
              />

              <input
                type='email'
                name='line1'
                placeholder='Email'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className='form-input'
              />
              <input
                type='text'
                name='purpose'
                placeholder='Purpose of contact'
                value={purpose}
                onChange={(e) => setPurpose(e.target.value)}
                className='form-input'
              />

              <button
                type='submit'
                disabled={isBtnDisabled}
                className='confirm-btn'
              >
                Confirm
              </button>
            </form>
          </div>
        </div>
      </Wrapper>
    </main>
  );
};

export default ContactUsPage;
